import { useEffect } from "react";
import { HeaderBar } from "./components/HeaderBar";
import { BuildPanel } from "./components/BuildPanel";
import { ViewportPanel } from "./components/ViewportPanel";
import { InspectorPanel } from "./components/InspectorPanel";
import { VersionSetupScreen } from "./components/VersionSetupScreen";
import {
  TOOL_DEFINITIONS,
  useEditorStore
} from "./store/editorStore";

export function App() {
  const projectVersionId = useEditorStore(
    (state) => state.projectVersionId
  );

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const target = event.target;
      const tagName =
        target instanceof HTMLElement
          ? target.tagName.toLowerCase()
          : "";
      const typing = ["textarea", "input", "select"].includes(
        tagName
      );
      const state = useEditorStore.getState();

      if (!typing && ["1", "2", "3", "4"].includes(event.key)) {
        const tool = TOOL_DEFINITIONS[Number(event.key) - 1];
        if (tool) state.setActiveTool(tool.id);
      }

      const modifier = event.ctrlKey || event.metaKey;
      if (modifier && event.key.toLowerCase() === "z") {
        event.preventDefault();
        event.shiftKey ? state.redo() : state.undo();
      }

      if (modifier && event.key.toLowerCase() === "y") {
        event.preventDefault();
        state.redo();
      }

      if (!typing && modifier && event.key.toLowerCase() === "c") {
        event.preventDefault();
        state.copySelection();
      }

      if (!typing && modifier && event.key.toLowerCase() === "x") {
        event.preventDefault();
        state.cutSelection();
      }

      if (!typing && modifier && event.key.toLowerCase() === "v") {
        event.preventDefault();
        state.pasteClipboard();
      }

      if (!typing && event.key === "Delete") {
        state.deleteSelected();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  if (!projectVersionId) {
    return <VersionSetupScreen />;
  }

  return (
    <div id="app">
      <HeaderBar />
      <main className="studio-layout">
        <BuildPanel />
        <ViewportPanel />
        <InspectorPanel />
      </main>
    </div>
  );
}
